module.exports = __webpack_public_path__ + "img/insta360.C1QBOoVs.50746eff.png";